var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icView") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-who-is-in-the-group-chat",
    transform: "translate(-27.000000, -539.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 498.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(19.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icView"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90962176,14.180507 C12.8907893,14.180507 15.3198888,11.7574301 15.3198888,8.78365385 L15.3198888,5.39685315 C15.3198888,2.42307692 12.8907893,0 9.90962176,0 C6.92845421,0 4.49935473,2.42307692 4.49935473,5.39685315 L4.49935473,8.81118881 C4.47175132,11.7574301 6.90085081,14.180507 9.90962176,14.180507 Z M5.41072682,5.22995238 C5.41072682,2.932707 7.58213874,1.05863841 9.88509392,1.05863841 C12.1880491,1.05863841 14.5024155,2.90248009 14.5024155,5.19972547 L14.5024155,8.94786266 C14.5024155,11.245108 12.1880491,13.1494036 9.88509392,13.1494036 C7.58213874,13.1494036 5.41072682,11.245108 5.41072682,8.94786266 L5.41072682,5.22995238 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5984163,23.3496503 L19.5984163,21.5323427 C19.5984163,19.9903846 18.7703142,18.5310315 17.4729542,17.7325175 L13.5808744,15.3645105 C12.8631859,14.923951 12.0626872,14.7036713 11.2345851,14.7036713 L8.33622777,14.7036713 C7.50812568,14.7036713 6.68002358,14.923951 5.9623351,15.3920455 L2.18066885,17.7325175 C0.8557055,18.5585664 0.0828102097,19.9628497 0.0828102097,21.5048077 L0.0828102097,23.3496503 C0.0828102097,23.7902098 0.441654452,24.1481643 0.883308903,24.1481643 L18.825521,24.1481643 C19.239572,24.1481643 19.5984163,23.7902098 19.5984163,23.3496503 Z M1.18412663,23.2198465 L1.18412663,21.1506211 C1.18412663,20.0928459 1.74229375,19.2218335 2.6554197,18.6635632 L6.56067416,16.1689215 C7.06142064,15.875095 7.6386646,15.7277136 8.19832244,15.7277136 L11.2911684,15.7277136 C11.8508262,15.7277136 12.517136,15.875095 13.0178825,16.1689215 L17.0268705,18.6635632 C18.1099265,19.3006755 18.5469891,20.6175179 18.5469891,21.6459104 L18.5469891,23.1117171 L1.18412663,23.2198465 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewWhite);
export default __webpack_public_path__ + "static/media/icViewWhite.b0df844b8be1deadfc7be4558a38452c.svg";
export { ForwardRef as ReactComponent };